export default __webpack_public_path__ + "static/media/blog5.bb390b00.jpg";